import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import ProductCardOrderEnum from '../../enums/ProductCardOrderEnum.js';
const FUNCTION_ICON_SIZE = 40;
const CONTAINER_MAX_WIDTH = 600;
/**
 * A class with style.
 */
export default class InformationCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.hasHomeDelivery Has Home delivery.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color, border } = options.theme;
        return css `
			${Text.CSS}

			:host {
				display: block;
			}

			.container {
				position: relative;
				display: flex;
				flex-direction: column;
				padding: ${spacing.space100 / 16}rem;
				outline: none;
				max-width: ${CONTAINER_MAX_WIDTH / 16}rem;
			}

			kompis-product-card-media {
				order: ${ProductCardOrderEnum.beforeFirstFocusElement};
			}

			.priceModuleWrapper {
				margin-top: ${spacing.space150 / 16}rem;
				display: flex;
				order: ${ProductCardOrderEnum.firstFocusElement};
			}

			kompis-injury-or-death-warning {
				margin-top: ${spacing.space100 / 16}rem;
				order: ${ProductCardOrderEnum.firstFocusElement};
			}

			kompis-product-card-water-sense-image {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
			}

			.functionIcons {
				display: flex;
				position: absolute;
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				top: ${spacing.space100 / 16}rem;
				left: ${spacing.space100 / 16}rem;
				right: ${spacing.space100 / 16}rem;
			}

			slot,
			::slotted(*) {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
			}

			.slotDivider {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
			}

			kompis-home-delivery {
				display: flex;
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				margin-top: ${spacing.space100 / 16}rem;
			}

			.storeAvailability {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				margin-top: ${options.hasHomeDelivery ? spacing.space50 / 16 : spacing.space100 / 16}rem;
			}

			.homeDeliveryDivider {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
			}

			.productDescription {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				color: ${color.text.default};
				margin-top: ${spacing.space100 / 16}rem;
			}

			.productIdentifier {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				margin-top: ${spacing.space75 / 16}rem;
			}

			kompis-product-information-section {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				display: block;
				border-top: ${1 / 16}rem solid ${color.border.light};
				margin-top: ${spacing.space200 / 16}rem;
			}

			.priceModuleWrapper kompis-price-module {
				flex-shrink: 1;
				flex-grow: 1;
			}

			kompis-function-icon {
				display: block;
				width: ${FUNCTION_ICON_SIZE / 16}rem;
				margin: ${spacing.space25 / 16}rem;
			}

			.divider {
				margin-top: ${spacing.space100 / 16}rem;
				border-top: ${border.thickness.thin / 16}rem solid ${color.border.light};
			}

			kompis-do-not-diy {
				order: ${ProductCardOrderEnum.afterFirstFocusElement};
				margin-top: ${spacing.space100 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=InformationCardStyle.js.map